import { useEffect, useRef } from 'react';

import { ERROR_VALIDATE } from '../lib/Error';
import Reducer from '../modules/reducers/Reducer';

export const useInput = ({
  initialState = { name: '' },
  validate = { name: () => undefined },
  error = ERROR_VALIDATE,
}) => {
  const [state, setValue, onChange, setValueAll] = Reducer(initialState);
  const inputRef = useRef([]);

  useEffect(() => {
    setValueAll({ object: initialState });
  }, []);

  const onValidate = (e) => {
    const { name, value } = e.target;
    setValueAll({
      object: {
        [`${name}Error`]: validate[name](value) ? error[name] : null,
      },
    });
  };

  const onChangeValue = (e) => {
    onChange(e);
    onValidate(e);
  };

  const onKeyPress = (e, submit) => {
    if (e.key === 'Enter') {
      submit();
    }
  };

  return {
    state,
    setValue,
    setValueAll,
    onValidate,
    onKeyPress,
    onChangeValue,
    inputRef,
    onChange,
  };
};
